import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video_icon_like",
  "use": "icon-video_icon_like-usage",
  "viewBox": "0 0 13 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 12\" id=\"icon-video_icon_like\"><g stroke=\"#FFF\" stroke-linecap=\"round\" stroke-width=\".8\" fill-rule=\"nonzero\" fill=\"none\"><path d=\"M6.397 1c.773 0 1.057 1.32 1.057 3.195h2.653c.549 0 .838 1.482.484 3.09-.325 1.476-1.247 3.09-1.802 3.09h-6.6 0a.874.874 0 0 1-.874-.874V5.069c0-.483.392-.874.874-.874h1.776S4.97 3.765 5.223 2.6 5.625 1 6.397 1Z\" stroke-linejoin=\"round\" /><path d=\"M3.288 4.195v6.18\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol